import { render, staticRenderFns } from "./Co2SvgCode.vue?vue&type=template&id=6f7a1924"
import script from "./Co2SvgCode.vue?vue&type=script&lang=js"
export * from "./Co2SvgCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports